import { FC, useEffect, useState } from 'react';
import { Prism } from 'react-syntax-highlighter';
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import gfm from 'remark-gfm';
import { colors } from '../config/theme';

interface ProblemProps {
  file: string;
}

export const Problem: FC<ProblemProps> = ({ file }) => {
  const [md, setMd] = useState('');
  const [source, setSource] = useState('');
  const [isSourceShown, setIsSourceShown] = useState(false);

  useEffect(() => {
    fetch(`../../problems/${file}.md`)
      .then((data) => data.text())
      .then(setMd);

    fetch(`../../problems/${file}.cpp`)
      .then((data) => data.text())
      .then(setSource);

    setIsSourceShown(localStorage.getItem('source') === '1');
  }, [file]);

  const toggleSource = () => {
    setIsSourceShown(!isSourceShown);
  };

  const saveSource = () => {
    localStorage.setItem('source', isSourceShown ? '1' : '0');
  };

  return (
    <Wrapper>
      <ReactMarkdown plugins={[[gfm]]}>{md}</ReactMarkdown>

      {!!md && (
        <>
          <h3>Sursa propusa</h3>
          <div className="source">
            <button onClick={toggleSource}>
              {isSourceShown ? 'Ascunde' : 'Arata'} sursa
            </button>
            <button onClick={saveSource}>Retine preferinta</button>
            {isSourceShown && (
              <Prism language="cpp" style={materialDark}>
                {source}
              </Prism>
            )}
          </div>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-left: 400px;
  margin-right: 100px;
  padding-bottom: 50px;
  max-width: 900px;
  text-align: justify;

  color: ${colors.blue_grey_900};

  .source {
    margin-top: 24px;

    button {
      margin-right: 16px;
      margin-bottom: 16px;
      border: none;
      outline: none;
      background: ${colors.blue_grey_300};
      cursor: pointer;
      padding: 16px 32px;
      border-radius: 8px;
      width: 175px;

      :hover {
        background: ${colors.blue_grey_400};
      }

      :active {
        background: ${colors.blue_grey_300};
      }
    }
  }

  table {
    margin-left: 24px;
    line-height: 1.5;
    padding-bottom: 5px;
  }

  th,
  td {
    padding-right: 20px;
  }

  th {
    font-weight: bold;
  }

  h1 {
    letter-spacing: 1.5px;
    font-size: 36px;
    padding-bottom: 50px;
    padding-top: 50px;
    text-align: center;
  }

  h3 {
    font-size: 24px;
    padding-top: 24px;
    line-height: 2;
  }

  h3::before {
    content: '#';
    margin-right: 8px;
    color: ${colors.yellow_vivid_500};
  }

  p,
  ul,
  li {
    padding-left: 24px;
    line-height: 1.5;
    padding-bottom: 5px;
  }

  li > ul {
    padding-left: 12px;
    padding-bottom: 0;
  }

  li::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: ${colors.yellow_vivid_500};
    margin-right: 10px;
    margin-left: -20px;
  }
`;
